import { useState, useEffect } from 'react';
import {
  useActionData,
  useNavigation,
  Form,
  Link,
} from 'react-router';

import useLocalStorage from 'hooks/useLocalStorage';

const FORM_FIELDS = ['email', 'name', 'message'];

const Contact = () => {
  const actionData = useActionData();
  const navigation = useNavigation();
  const { getItem, setItem, clear: clearLocalStorage } = useLocalStorage(FORM_FIELDS);
  const [email, setEmail] = useState(getItem('email') ?? '');
  const [name, setName] = useState(getItem('name') ?? '');
  const [message, setMessage] = useState(getItem('message') ?? '');
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);

  const isSubmitting = navigation.state === 'submitting';

  useEffect(() => {
    if (!actionData) {
      return;
    }

    setErrors({});

    if (actionData.success === true) {
      setSuccess(true);
      clearLocalStorage();
    }

    if (actionData.errors !== undefined) {
      setErrors(actionData.errors);
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [actionData, clearLocalStorage]);

  const handleChange = (field, value) => {
    if (field === 'email') {
      setEmail(value);
      setErrors({ message: errors.message, email: undefined });
    }

    if (field === 'name') {
      setName(value);
    }

    if (field === 'message') {
      setMessage(value);
      setErrors({ message: undefined, email: errors.email });
    }

    setItem(field, value);
  };

  return (
    <div className="container">
      <div className="contact page">
        <Link to="/">
          <div className="close">
            Close
            <span className="close-icon">X</span>
          </div>
        </Link>
        {success ? (
          <>
            <h3>Thanks! Your message has been sent</h3>
            <Link to="/" className="link back-link">Back to Home Page</Link>
          </>
        ) : (
          <Form method="POST">
            <h2>Send a Message</h2>
            {errors.serverError !== undefined && (
              <div className="error-hint">{errors.serverError}</div>
            )}
            <label htmlFor="email">Your Email</label>
            <input
              id="email"
              name="email"
              type="text"
              autoComplete="email"
              value={email}
              className={errors.email !== undefined ? 'error' : null}
              onChange={(event) => handleChange('email', event.target.value)}
            />
            {errors.email !== undefined && (
              <div className="error-hint">{errors.email}</div>
            )}
            <label htmlFor="name">Name</label>
            <input
              id="name"
              name="name"
              type="text"
              value={name}
              onChange={(event) => handleChange('name', event.target.value)}
            />
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              type="text"
              value={message}
              className={errors.message !== undefined ? 'error' : null}
              onChange={(event) => handleChange('message', event.target.value)}
            />
            {errors.message !== undefined && (
              <div className="error-hint">{errors.message}</div>
            )}
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting' : 'Submit'}
            </button>
          </Form>
        )}
      </div>
    </div>
  );
};

export default Contact;
